import { Dispatch } from "redux";
import { AuthActionTypes, AuthCreateAction } from "../../types/auth/auth";
import axios from "axios";

interface ErrorResponse {
    code: string | number;
    message: string;
    details?: any[];
}

export const auth = (data: { ident_field: string; ident_value: string }) => {
    return async (dispatch: Dispatch<AuthCreateAction>) => {
        try {
            dispatch({ type: AuthActionTypes.FETCH_AUTH_DATA });

            const response = await axios({
                method: 'post',
                url: `/api/auth`,
                data: {
                    ident_field: data.ident_field,
                    ident_value: data.ident_value,
                },
                withCredentials: false,
            });

            dispatch({
                type: AuthActionTypes.FETCH_AUTH_DATA_SUCCESS,
                payload: response.data ?? response.status,
            });

        } catch (error: any) {
            let errorPayload: ErrorResponse = {
                code: -1,
                message: 'Unknown error occurred',
                details: [],
            };

            if (axios.isAxiosError(error)) {
                const responseData = error.response?.data;

                if (responseData?.error) {
                    errorPayload = {
                        code: responseData.error.code,
                        message: responseData.error.message,
                        details: responseData.error.details || [],
                    };
                } else if (typeof responseData === 'string') {
                    errorPayload = {
                        code: error.response?.status || -1,
                        message: responseData,
                        details: [],
                    };
                } else {
                    errorPayload = {
                        code: error.response?.status || -1,
                        message: error.message || 'Unknown error occurred',
                        details: [],
                    };
                }
            }

            dispatch({
                type: AuthActionTypes.FETCH_AUTH_DATA_ERROR,
                payload: errorPayload,
            });
        }
    };
};

export const clearAuthData = () => {
    return (dispatch: Dispatch<AuthCreateAction>) => {
        dispatch({
            type: AuthActionTypes.CLEAR_AUTH_DATA,
            payload: []
        });
    };
};